<template>
    <div id="app" :class="{'nav-open': isNavOpened}">
        <Navigation :uacLevel="uacLevel" @navigation="menuNavigation()" />
        <div class="screen-wrapper">
            <Header :component="component" @navigation="menuNavigation()" />
            <router-view @changed="changeComponent"></router-view>
        </div>
    </div>
</template>

<script>
import Header from "./components/Header";
import Navigation from "./components/Navigation";
export default {
    name: "app",
    data() {
        return {
            isNavOpened: false,
            component: "",
            uacLevel: 1
        };
    },
    components: { Header, Navigation },
    methods: {
        menuNavigation(data) {
            this.isNavOpened = !this.isNavOpened;
        },
        changeComponent(data) {
            this.component = data;
        }
    }
};
</script>

<style>
@import "./assets/css/normalize.css";
@import "./assets/css/fonts.css";
@import "./assets/css/style.css";
</style>
